<template>
  <v-row>
    <v-col cols="12" sm="6" md="4">
      <v-menu
        v-model="startDateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="moment(startDate).format('MM-DD-YYYY')"
            label="START DATE"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="startDate"
          @input="startDateMenu = false"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="12" sm="6" md="4">
      <v-menu
        v-model="endDateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="moment(endDate).format('MM-DD-YYYY')"
            label="END DATE"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="endDate"
          @input="endDateMenu = false"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-col cols="12" sm="6" md="4">
      <v-btn @click="download()" color="primary">EXPORT</v-btn>
    </v-col>
    <v-spacer></v-spacer>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    startDate: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    startDateMenu: false,
    endDateMenu: false,
  }),
  mounted() {
    this.startDate = this.moment().subtract(30, "days").format("YYYY-MM-DD");
  },
  methods: {
    download() {
      // console.log("submitted");
      // console.log(this.startDate);
      // console.log(this.endDate);
      //OID40004
      this.$http
        .request({
          url:
            this.$store.getters.getBaseUrl +
            "audit/?startDate=" +
            this.startDate +
            "&endDate=" +
            this.endDate,
          method: "GET",
          responseType: "blob",
        })
        .then((result) => {
          const url = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "auditTrailing.csv"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },
  },
  // computed: {
  //   computedDateFormattedMomentjs() {
  //     return this.startDate
  //       ? this.moment(this.startDate).format("MM-DD-YYYY")
  //       : "";
  //   },
  // },
};
</script>